import { CustomerRouteConstants } from '@/customer/constants/RouteConstants';

export const Examples = {
  ExamplesIndex: {
    path: '/examples',
    name: 'examplesIndex'
  },
  ExampleErrors: {
    path: '/exampleerrors',
    name: 'exampleErrors',
    meta: { title: 'Errors' }
  },
  ExampleWithErrorPage: {
    path: '/examplewitherrorpage/:errorType',
    name: 'exampleWithErrorPage',
    meta: { title: 'Error Page' }
  },
  ExampleMstorePageRange: {
    path: '/examplemstorepagerange/',
    name: 'examplemstorepagerange',
    meta: { title: 'Mstore Page Range' }
  },
  ExampleMStoreQuickActions: {
    path: '/examplemstorequickactions/',
    name: 'examplemstorequickactions',
    meta: { title: 'Mstore Quick Actions' }
  },
  ExampleMStoreOrderableTable: {
    path: '/examplemstoreorderabletable/',
    name: 'examplemstoreorderabletable',
    meta: { title: 'Mstore Orderable Table' }
  },
  ExampleMStoreAccordion: {
    path: '/examplemstoreaccordion/',
    name: 'examplemstoreaccordion',
    meta: { title: 'Mstore Accordion' }
  },
  ExampleMStoreMakeChangesLock: {
    path: '/examplemstoremakechangeslock/',
    name: 'examplemstoremakechangeslock',
    meta: { title: 'Mstore Make Changes Lock' }
  },
  ExampleReferenceToggleModal: {
    path: '/examplereferencetogglemodal/',
    name: 'examplereferencetogglemodal',
    meta: { title: 'Reference Toggle Modal' }
  },
  ExampleMStoreReferenceSelectionModal: {
    path: '/examplemstorereferenceselectionmodal/',
    name: 'examplemstorereferenceselectionmodal',
    meta: { title: 'Mstore Reference Selection Modal' }
  },
  ExampleMStoreDeleteConfirmation: {
    path: '/examplemstoredeleteconfirmation/',
    name: 'examplemstoredeleteconfirmation',
    meta: { title: 'Mstore Delete Confirmation' }
  },
  ExampleReferencesAccordion: {
    path: '/examplereferencesaccordion/',
    name: 'examplereferencesaccordion',
    meta: { title: 'References Accordion' }
  },
  ExampleErrorNotification: {
    path: '/exampleerrornotification',
    name: 'exampleerrornotification',
    meta: { title: 'Error Notification' }
  },
  ExampleMStoreSpinnerButton: {
    path: '/examplemstorespinnerbutton',
    name: 'examplemstorespinnerbutton',
    meta: { title: 'Mstore Spinner Button' }
  },
  ExampleDirtyChanges: {
    path: '/exampledirtychanges',
    name: 'exampledirtychanges',
    meta: { title: 'Dirty Changes' }
  },
  ExampleMStoreRecurrence: {
    path: '/examplemstorerecurrence',
    name: 'examplemstorerecurrence',
    meta: { title: 'Mstore Recurrence' }
  },
  ExampleBuiltInListDynamicFormModal: {
    path: '/examplebuiltinlistdynamicformmodal',
    name: 'examplebuiltinlistdynamicformmodal',
    meta: { title: 'Built-In List Dynamic Form Modal' }
  },
  ExampleMStoreTable: {
    path: '/examplemstoretable/',
    name: 'examplemstoretable',
    meta: { title: 'Mstore Table' }
  },
  Sandbox: {
    path: '/sandbox',
    name: 'sandbox',
    meta: { title: 'Sandbox' }
  },
  ...CustomerRouteConstants.Examples,
  ExampleMStoreColumnConfiguration: {
    path: '/examplemstorecolumnconfiguration',
    name: 'examplemstorecolumnconfiguration',
    meta: { title: 'Mstore Column Configuration' }
  },
  ExampleDocumentEmailToMeModal: {
    path: '/exampledocumentemailtomemodal',
    name: 'exampledocumentemailtomemodal',
    meta: { title: 'Document Email To Me Modal' }
  },
  ExampleDebug: {
    path: '/exampledebug',
    name: 'exampledebug',
    meta: { title: 'Debug' }
  }
};
